import React, { useContext } from 'react';
import {
	useCurrentLanguage,
	useTranslationHelpBlog,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@dealstack/frontend/app/pages/Routing/routes.ts';
import { useHelpBlogBreadcrumbs } from '@dealstack/frontend/app/pages/HelpBlog/useHelpBlogBreadcrumbs.tsx';
import { CategoriesPageContainer } from '@dealstack/frontend/app/pages/HelpBlog/CategoriesPage/CategoriesPage.styles.tsx';
import { HelpBlogLayout } from '@dealstack/frontend/app/pages/HelpBlog/HelpBlogLayout/HelpBlogLayout.tsx';
import { Flex, Text, Title } from '@mantine/core';
import { useCategories } from '@dealstack/frontend/app/pages/HelpBlog/api/useCategories.ts';
import { FullscreenLoader } from '@dealstack/frontend/shared/components/loaders/FullLoaderScreenLoader/FullLoaderScreenLoader.tsx';
import { QuickSwitchBreadcrumbsNav } from '@dealstack/frontend/shared/components/QuickSwitchBreadcrumbsNav/QuickSwitchBreadcrumbsNav.tsx';
import { HelpBlogContext } from '@dealstack/frontend/app/pages/HelpBlog/useHelpBlogController.tsx';
import { HELP_BLOG_ROUTES } from '@dealstack/frontend/shared/shared-routes.ts';

export const CategoriesPage = () => {
	const { dataset, perspective } = useContext(HelpBlogContext);
	const tHelpBlog = useTranslationHelpBlog();
	const currentLanguage = useCurrentLanguage();
	const navigate = useNavigate();
	const { categories, isFetching } = useCategories(dataset, currentLanguage, perspective);

	useHelpBlogBreadcrumbs([
		{
			name: tHelpBlog('breadcrumbs.help-title'),
			url: ROUTES.HELP_BLOG,
		},
		{
			name: tHelpBlog('breadcrumbs.help.categories'),
			url: `/${HELP_BLOG_ROUTES.CATEGORIES}`,
			noLink: true,
		},
	]);

	if (isFetching) {
		return <FullscreenLoader name="pageLoading" />;
	}

	return (
		<HelpBlogLayout>
			<CategoriesPageContainer>
				<div className="container">
					<div className="breadcrumbs">
						<QuickSwitchBreadcrumbsNav showQuickSwitch={false} />
					</div>

					<div className="header">
						<Title size="h1" fw={600} className="title">
							{tHelpBlog('categories.title')}
						</Title>

						<Text className="meta-text">
							{categories.length}{' '}
							{categories.length > 1
								? tHelpBlog('categories.count_plural')
								: tHelpBlog('categories.count')}
						</Text>
					</div>

					<Flex direction="column" gap="1rem">
						{categories.map((cat) => (
							<div
								className="category"
								key={cat.id}
								onClick={() => navigate(cat.slug.current)}
							>
								<Title size="h4" className="title" fw={600}>
									{cat.name}
								</Title>

								<Text className="meta-text">
									{cat.postsCount}{' '}
									{cat.postsCount > 1
										? tHelpBlog('categories.post_count_plural')
										: tHelpBlog('categories.posts_count')}
								</Text>
							</div>
						))}
					</Flex>
				</div>
			</CategoriesPageContainer>
		</HelpBlogLayout>
	);
};
